module.exports = __webpack_public_path__ + "media/dashboard/assets/images/banners/octopus-bg-e2351f8d22af64543f5a9b1a544f90a0.gif";